import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { getAssetUrl as t } from "../../assets.js";
import s from "../../config.js";
import r from "../../Graphic.js";
import o from "../../PopupTemplate.js";
import "../../symbols.js";
import l from "../../core/Accessor.js";
import i from "../../core/Collection.js";
import { deprecatedProperty as a } from "../../core/deprecate.js";
import n from "../../core/Error.js";
import u from "../../core/Evented.js";
import c from "../../core/Handles.js";
import h from "../../core/has.js";
import p from "../../core/Logger.js";
import { unwrap as d, isSome as g } from "../../core/maybe.js";
import { eachAlways as m, after as y } from "../../core/promiseUtils.js";
import { on as f, init as S, whenFalseOnce as v, whenOnce as _ } from "../../core/watchUtils.js";
import { property as b } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as w } from "../../core/accessorSupport/decorators/subclass.js";
import x from "../../geometry/Point.js";
import I from "../../geometry/SpatialReference.js";
import { onLocaleChange as j } from "../../intl/locale.js";
import { fetchMessageBundle as P } from "../../intl/messages.js";
import T from "../../portal/Portal.js";
import { highlightsSupported as R } from "../../views/support/layerViewUtils.js";
import L from "./LayerSearchSource.js";
import E from "./LocatorSearchSource.js";
import C from "./SearchSource.js";
import { getPointFromGeometry as F, getPointWithElevation as O } from "./support/geometryUtils.js";
import { isArcGISWorldGeocoder as A, meteredArcGISLocatorUrl as G, isProxiedArcGISWorldGeocoder as N, isMeteredArcGISWorldGeocoder as D } from "./support/locatorUtils.js";
import { supported as M, getCurrentPosition as V, positionToPoint as k } from "../support/geolocationUtils.js";
import { GoToMixin as B } from "../support/GoTo.js";
import J from "../../symbols/PictureMarkerSymbol.js";
import U from "../../symbols/SimpleLineSymbol.js";
import H from "../../symbols/SimpleFillSymbol.js";
import Q from "../../symbols/TextSymbol.js";

function Z(e, t) {
  return e.hasOwnProperty(t) && null != e[t] && "" !== e[t];
}

var q = function q() {
  return P("esri/widgets/Search/t9n/Search");
},
    z = "esri.widgets.Search.SearchViewModel",
    K = p.getLogger(z),
    W = "highlight",
    X = i.ofType({
  key: function key(e) {
    return e.layer ? "layer" : "locator";
  },
  base: C,
  typeMap: {
    layer: L,
    locator: E
  }
}),
    Y = I.WGS84,
    $ = "esri/images/search/search-symbol-32.svg",
    ee = "esri/images/search/search-symbol-32.png",
    te = /<(?:.|\s)*?>/g,
    se = -1;

var re = /*#__PURE__*/function (_B) {
  _inherits(re, _B);

  var _super = _createSuper(re);

  function re(e) {
    var _this;

    _classCallCheck(this, re);

    _this = _super.call(this, e), _this._handles = new c(), _this._gotoController = null, _this._searching = null, _this.autoNavigate = !0, _this.autoSelect = !0, _this.defaultPopupTemplate = null, _this.defaultSources = new X(), _this.defaultSymbols = {
      point: new J({
        url: t(h("trident") ? ee : $),
        size: 24,
        width: 24,
        height: 24
      }),
      polyline: new U({
        color: [130, 130, 130, 1],
        width: 2
      }),
      polygon: new H({
        color: [235, 235, 235, .4],
        outline: {
          color: [130, 130, 130, 1],
          width: 2
        }
      })
    }, _this.includeDefaultSources = !0, _this.maxInputLength = 128, _this.maxResults = 6, _this.maxSuggestions = 6, _this.messages = null, _this.minSuggestCharacters = 3, _this.popupEnabled = !0, _this.popupTemplate = null, _this.portal = T.getDefault(), _this.resultCount = null, _this.resultGraphicEnabled = !0, _this.resultGraphic = null, _this.results = null, _this.selectedSuggestion = null, _this.searchAllEnabled = !0, _this.selectedResult = null, _this.sources = new X(), _this.suggestionDelay = 350, _this.suggestionCount = null, _this.suggestions = null, _this.suggestionsEnabled = !0, _this.view = null;
    return _this;
  }

  _createClass(re, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      var e = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var e;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return q();

                case 2:
                  e = _context.sent;
                  _this2.messages = e, _this2.defaultPopupTemplate = new o({
                    title: e.searchResult,
                    content: "{Match_addr}"
                  });

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function e() {
          return _ref.apply(this, arguments);
        };
      }();

      e(), this._handles.add([f(this, ["defaultSources", "sources"], "change", function () {
        return _this2.notifyChange("allSources");
      }), S(this, ["includeDefaultSources", "view", "portal"], function () {
        return _this2._update();
      }), j(e)]);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._abortGoTo(), this.clearGraphics(), this._handles.destroy(), this._handles = null;
    }
  }, {
    key: "activeSource",
    get: function get() {
      return this.allSources.getItemAt(this.activeSourceIndex) || null;
    }
  }, {
    key: "activeSourceIndex",
    get: function get() {
      return 1 === this.allSources.length || !this.searchAllEnabled ? 0 : se;
    },
    set: function set(e) {
      void 0 !== e ? this._override("activeSourceIndex", e) : this._clearOverride("activeSourceIndex");
    }
  }, {
    key: "allPlaceholder",
    get: function get() {
      var e;
      return null == (e = this.messages) ? void 0 : e.allPlaceholder;
    },
    set: function set(e) {
      e ? this._override("allPlaceholder", e) : this._clearOverride("allPlaceholder");
    }
  }, {
    key: "allSources",
    get: function get() {
      var e = this.sources,
          t = this.defaultSources,
          s = this.includeDefaultSources,
          r = "function" == typeof s ? s.call(null, {
        sources: e,
        defaultSources: t
      }) : s ? t.concat(e) : e,
          o = this._get("allSources") || new X();
      return o.removeAll(), o.addMany(r.filter(Boolean)), o;
    }
  }, {
    key: "defaultSymbol",
    get: function get() {
      return a(K, "defaultSymbol", {
        replacement: "defaultSymbols",
        version: "4.22"
      }), this._get("defaultSymbol");
    },
    set: function set(e) {
      a(K, "defaultSymbol", {
        replacement: "defaultSymbols",
        version: "4.22"
      }), this._set("defaultSymbol", e);
    }
  }, {
    key: "locationEnabled",
    get: function get() {
      return this._get("locationEnabled") || M();
    },
    set: function set(e) {
      if (void 0 === e) return void this._clearOverride("locationEnabled");
      var t = M();

      if (e && !t) {
        var _e = new n("locationEnabled:geolocation-unsupported", "Geolocation API is unsupported.", {
          geolocation: navigator.geolocation
        });

        K.error(_e);
      }

      this._override("locationEnabled", e && t);
    }
  }, {
    key: "placeholder",
    get: function get() {
      var e = this.allSources,
          t = this.activeSourceIndex,
          s = this.allPlaceholder;
      if (t === se) return s;
      var r = e.getItemAt(t);
      return r ? r.placeholder : "";
    }
  }, {
    key: "searchTerm",
    get: function get() {
      return this._get("searchTerm") || "";
    },
    set: function set(e) {
      this._set("searchTerm", e || ""), this.clearGraphics(), this.selectedSuggestion && this.selectedSuggestion.text !== e && this._set("selectedSuggestion", null), "" === e && this._clear();
    }
  }, {
    key: "state",
    get: function get() {
      return this._searching ? "searching" : this.updating ? "loading" : 0 === this.allSources.length ? "disabled" : "ready";
    }
  }, {
    key: "updating",
    get: function get() {
      return null != this._updatingPromise;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.searchTerm = "";
    }
  }, {
    key: "clearGraphics",
    value: function clearGraphics() {
      this._removeHighlight(), this._closePopup(), this.view && this.view.graphics.remove(this.resultGraphic), this._set("resultGraphic", null);
    }
  }, {
    key: "search",
    value: function search(e, t) {
      var _this3 = this;

      this.emit("search-start"), this.clearGraphics();

      var s = this._createSuggestionForSearch(e),
          r = this.when().then(function () {
        return _this3._getResultsFromSources(s, t).then(function (e) {
          var r;
          if (null != (r = d(null == t ? void 0 : t.signal)) && r.aborted) return null;
          var o = {
            activeSourceIndex: _this3.activeSourceIndex,
            searchTerm: s.text,
            numResults: 0,
            numErrors: 0,
            errors: [],
            results: []
          };

          _this3._formatResponse(o, e, s);

          var l = _this3._getFirstResult(o.results),
              i = (s.location && l ? l.name : s.text).replace(te, "");

          return _this3._set("searchTerm", i), (s.key && "number" == typeof s.sourceIndex || s.location) && _this3._set("selectedSuggestion", s), _this3._set("results", o.results), _this3._set("resultCount", o.results.reduce(function (e, t) {
            return e + t.results.length;
          }, 0)), _this3.emit("search-complete", o), _this3._selectFirstResult(l).then(function () {
            return o;
          });
        });
      }).then(function (e) {
        return _this3._clearSearching(), e;
      }, function (e) {
        throw _this3._clearSearching(), e;
      });

      return this._searching = r, this.notifyChange("state"), r;
    }
  }, {
    key: "searchNearby",
    value: function searchNearby(e) {
      var _this4 = this;

      if (!this.locationEnabled) {
        var _e2 = new n("searchNearby:geolocation-unsupported", "Geolocation API is unsupported.", {
          geolocation: navigator.geolocation
        });

        return K.error(_e2), Promise.reject(_e2);
      }

      var t = V().then(function (t) {
        return k({
          position: t,
          view: _this4.view
        }, e);
      }).then(function (t) {
        return _this4.search(t, e);
      });
      return this._searching = t, this.notifyChange("state"), t.catch(function () {}).then(function () {
        return _this4._clearSearching();
      }), t;
    }
  }, {
    key: "select",
    value: function select(e) {
      var _this5 = this;

      if (this.clearGraphics(), !e) {
        var _t = new n("select:missing-parameter", "Cannot select without a searchResult.", {
          searchResult: e
        });

        return K.error(_t), Promise.reject(_t);
      }

      var t = this.view,
          s = Z(e, "sourceIndex") ? e.sourceIndex : this._getSourceIndexOfResult(e),
          o = this.allSources.getItemAt(s);

      if (!o) {
        var _e3 = new n("select:missing-source", "Cannot select without a source.", {
          source: o
        });

        return K.error(_e3), Promise.reject(_e3);
      }

      var l = o instanceof L ? this._getLayerSourcePopupTemplate(o) : o.popupTemplate,
          i = o.resultSymbol || this._getDefaultSymbol(e),
          a = Z(o, "resultGraphicEnabled") ? o.resultGraphicEnabled : this.resultGraphicEnabled,
          u = Z(o, "autoNavigate") ? o.autoNavigate : this.autoNavigate,
          c = Z(o, "popupEnabled") ? o.popupEnabled : this.popupEnabled,
          h = c ? l || this.popupTemplate || this.defaultPopupTemplate : null,
          p = e.feature;

      if (!p) {
        var _e4 = new n("select:missing-feature", "Cannot select without a feature.", {
          feature: p
        });

        return K.error(_e4), Promise.reject(_e4);
      }

      var d = p.attributes,
          y = p.geometry,
          f = p.layer,
          S = p.sourceLayer,
          v = F(y),
          _ = {
        layerViewQuery: this._getLayerView(p),
        elevationQuery: t && g(v) ? O(v, t).catch(function () {
          return v;
        }) : Promise.resolve(v)
      };
      return m(_).then(function (l) {
        var n = l.layerViewQuery.value,
            m = l.elevationQuery.value;
        i instanceof Q && (i.text = e.name);
        var v = t && u ? e.target || e.extent : null;
        return (g(v) ? _this5._goToSearchResult(v) : Promise.resolve()).then(function () {
          var l;
          var u = n ? p : new r({
            geometry: y,
            symbol: i,
            attributes: d,
            layer: f,
            sourceLayer: S,
            popupTemplate: h
          }),
              g = c && (null == (l = _this5.view) ? void 0 : l.popup),
              v = g && u.getEffectivePopupTemplate(g.defaultPopupTemplateEnabled);
          return v && t.popup.open({
            features: [u],
            location: m
          }), n && R(n) && !v && _this5._highlightFeature({
            graphic: u,
            layerView: n
          }), !n && a && t && t.graphics.push(u), _this5._setResultFloor(e), _this5._set("selectedResult", e), _this5._set("resultGraphic", u), _this5.emit("select-result", {
            result: e,
            source: o,
            sourceIndex: s
          }), e;
        });
      });
    }
  }, {
    key: "suggest",
    value: function suggest(e, t, s) {
      var _this6 = this;

      var r = e || this.searchTerm;
      return this.emit("suggest-start", {
        searchTerm: r
      }), this._suggestTimer(t, s).then(function () {
        return _this6._suggestImmediate(r, s).then(function (e) {
          return _this6._set("suggestions", e.results), _this6._set("suggestionCount", e.results.reduce(function (e, t) {
            return e + t.results.length;
          }, 0)), _this6.emit("suggest-complete", e), e;
        });
      });
    }
  }, {
    key: "when",
    value: function () {
      var _when = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return v(this, "updating");

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function when() {
        return _when.apply(this, arguments);
      }

      return when;
    }()
  }, {
    key: "_update",
    value: function () {
      var _update2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var e, t, _s, s;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                e = this.portal, t = this.view;

                if (!this.includeDefaultSources) {
                  _context3.next = 10;
                  break;
                }

                _s = this._updatingPromise = m([null == e ? void 0 : e.load(), null == t ? void 0 : t.when()]);

                if (!this.destroyed) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:
                this.notifyChange("updating");
                _context3.next = 8;
                return _s;

              case 8:
                if (!(_s !== this._updatingPromise)) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt("return");

              case 10:
                this._updatingPromise = null, this.notifyChange("updating");
                s = _(this, "messages");
                _context3.t0 = this.destroyed;

                if (_context3.t0) {
                  _context3.next = 18;
                  break;
                }

                this._handles.add(s);

                _context3.next = 17;
                return s;

              case 17:
                this._updateDefaultSources();

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _update() {
        return _update2.apply(this, arguments);
      }

      return _update;
    }()
  }, {
    key: "_clearSearching",
    value: function _clearSearching() {
      this._searching = null, this.notifyChange("state");
    }
  }, {
    key: "_convertHelperServices",
    value: function _convertHelperServices() {
      var _this7 = this;

      var e, t;
      var r = null == (e = this.portal) || null == (t = e.helperServices) ? void 0 : t.geocode;
      if (!r) return [];
      return r.map(function (e) {
        if (!1 === e.placefinding) return;
        var t = s.apiKey && A(e.url) ? {
          url: G
        } : null,
            r = E.fromJSON(_objectSpread(_objectSpread({}, e), t)),
            o = r.url;

        if (A(o) || N(o) || D(o)) {
          var _e5 = r.outFields || ["Addr_type", "Match_addr", "StAddr", "City"],
              _t2 = r.placeholder || _this7.messages.placeholder,
              _s2 = "number" == typeof r.defaultZoomScale ? r.defaultZoomScale : 2500;

          r.set({
            singleLineFieldName: "SingleLine",
            outFields: _e5,
            placeholder: _t2,
            defaultZoomScale: _s2
          });
        }

        return r.singleLineFieldName ? r : void 0;
      }).filter(Boolean);
    }
  }, {
    key: "_getLayerSources",
    value: function _getLayerSources(e, t) {
      var _this8 = this;

      var s;
      var r = null == (s = this.view) ? void 0 : s.map;
      return e.map(function (e) {
        var s = r.findLayerById(e.id);
        if (!s) return;

        var o = _this8._getLayerJSON(e),
            l = L.fromJSON(o);

        return l.placeholder = t, _this8._getLayer(s, o).then(function (e) {
          l.layer = e;
        }), l;
      }).filter(Boolean).toArray();
    }
  }, {
    key: "_getTableSources",
    value: function _getTableSources(e, t) {
      var _this9 = this;

      var s;
      var r = null == (s = this.view) ? void 0 : s.map;
      return e.map(function (e) {
        var s = r.findTableById(e.id);
        if (!s) return;

        var o = _this9._getLayerJSON(e),
            l = L.fromJSON(o);

        return l.placeholder = t, _this9._getLayer(s, o).then(function (e) {
          l.layer = e;
        }), l;
      }).filter(Boolean).toArray();
    }
  }, {
    key: "_convertApplicationProperties",
    value: function _convertApplicationProperties() {
      var e, t, s;
      var r = null == (e = this.view) ? void 0 : e.map,
          o = null == r || null == (t = r.applicationProperties) || null == (s = t.viewing) ? void 0 : s.search;
      if (!o) return [];
      var l = o.enabled,
          i = o.hintText,
          a = o.layers,
          n = o.tables;
      if (!l) return [];
      return [].concat(_toConsumableArray(this._getLayerSources(a, i)), _toConsumableArray(this._getTableSources(n, i)));
    }
  }, {
    key: "_getSubLayer",
    value: function _getSubLayer(e, t) {
      return e.load().then(function () {
        if (!e.allSublayers) return Promise.reject();
        var s = e.allSublayers.find(function (e) {
          return e.id === t.subLayer;
        });
        return s ? s.createFeatureLayer() : Promise.reject();
      });
    }
  }, {
    key: "_getBuildingSubLayer",
    value: function () {
      var _getBuildingSubLayer2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e, t) {
        var s;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return e.load();

              case 2:
                s = e.allSublayers.find(function (e) {
                  return e.id === t.subLayer;
                });

                if (!("building-component" !== (null == s ? void 0 : s.type))) {
                  _context4.next = 7;
                  break;
                }

                _context4.t0 = Promise.reject();
                _context4.next = 17;
                break;

              case 7:
                _context4.next = 9;
                return s.load();

              case 9:
                if (!(null == s.associatedLayer)) {
                  _context4.next = 13;
                  break;
                }

                _context4.t1 = Promise.reject();
                _context4.next = 16;
                break;

              case 13:
                _context4.next = 15;
                return s.associatedLayer.load();

              case 15:
                _context4.t1 = s;

              case 16:
                _context4.t0 = _context4.t1;

              case 17:
                return _context4.abrupt("return", _context4.t0);

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function _getBuildingSubLayer(_x, _x2) {
        return _getBuildingSubLayer2.apply(this, arguments);
      }

      return _getBuildingSubLayer;
    }()
  }, {
    key: "_getLayer",
    value: function _getLayer(e, t) {
      return "feature" === e.type || "scene" === e.type || "csv" === e.type || "geojson" === e.type || "ogc-feature" === e.type ? Promise.resolve(e) : "map-image" === e.type ? this._getSubLayer(e, t).catch(function () {
        var t = new n("search:create-featurelayer", "Could not create a FeatureLayer from the MapImageLayer", {
          layer: e
        });
        return K.error(t), null;
      }) : "building-scene" === e.type ? this._getBuildingSubLayer(e, t) : Promise.resolve(null);
    }
  }, {
    key: "_getLayerJSON",
    value: function _getLayerJSON(e) {
      return "function" == typeof e.toJSON ? e.toJSON() : e;
    }
  }, {
    key: "_updateDefaultSources",
    value: function _updateDefaultSources() {
      var e = this.defaultSources,
          t = this.includeDefaultSources;
      e.removeAll(), t && e.addMany([].concat(_toConsumableArray(this._convertApplicationProperties()), _toConsumableArray(this._convertHelperServices()))), this.notifyChange("allSources");
    }
  }, {
    key: "_abortGoTo",
    value: function _abortGoTo() {
      this._gotoController && this._gotoController.abort(), this._gotoController = null;
    }
  }, {
    key: "_clear",
    value: function _clear() {
      this._abortGoTo(), this._set("resultCount", null), this._set("results", null), this._set("suggestions", null), this._set("suggestionCount", null), this._set("selectedResult", null), this._set("selectedSuggestion", null), this.emit("search-clear");
    }
  }, {
    key: "_closePopup",
    value: function _closePopup() {
      var e;
      var t = null == (e = this.view) ? void 0 : e.popup,
          s = this.resultGraphic;
      if (!t || !s) return;
      var r = t.selectedFeature;
      r && r === s && t.close();
    }
  }, {
    key: "_suggestTimer",
    value: function _suggestTimer(e, t) {
      var s = null != e ? e : this.suggestionDelay;
      return y(s, null, t && t.signal);
    }
  }, {
    key: "_createLocationForSearch",
    value: function _createLocationForSearch(e) {
      return e instanceof r ? F(e.geometry) : e instanceof x ? e : Array.isArray(e) && 2 === e.length ? new x({
        longitude: e[0],
        latitude: e[1]
      }) : null;
    }
  }, {
    key: "_createSuggestionForSearch",
    value: function _createSuggestionForSearch(e) {
      if (e && Z(e, "key") && Z(e, "text") && Z(e, "sourceIndex")) return e;

      var t = this._createLocationForSearch(e),
          s = "string" == typeof e ? e : this.searchTerm,
          r = this.selectedSuggestion,
          o = this.selectedResult,
          l = !e && r && o,
          i = l && r.key === o.key && r.sourceIndex === o.sourceIndex,
          a = l && r.location;

      return i || a ? r : {
        location: d(t),
        text: t ? "" : s,
        sourceIndex: null,
        key: null
      };
    }
  }, {
    key: "_getFirstResult",
    value: function _getFirstResult(e) {
      var t = null;
      return e && e.some(function (e) {
        var s = e.results,
            r = s[0],
            o = !!r;
        return o && (t = r), o;
      }), t;
    }
  }, {
    key: "_selectFirstResult",
    value: function _selectFirstResult(e) {
      return this.autoSelect && e ? this.select(e) : Promise.resolve(null);
    }
  }, {
    key: "_suggestImmediate",
    value: function _suggestImmediate(e, t) {
      var _this10 = this;

      return this.when().then(function () {
        return _this10._getSuggestionsFromSources(e, t);
      }).then(function (s) {
        var r;
        if (null != (r = d(null == t ? void 0 : t.signal)) && r.aborted) return null;
        var o = {
          activeSourceIndex: _this10.activeSourceIndex,
          searchTerm: e,
          numResults: 0,
          numErrors: 0,
          errors: [],
          results: []
        };
        return _this10._formatResponse(o, s), o;
      });
    }
  }, {
    key: "_formatSourceResponse",
    value: function _formatSourceResponse(e, t, s) {
      var r = t && t.value || [],
          o = t && t.error,
          l = this.allSources.getItemAt(s);

      if (o) {
        var _t3 = {
          sourceIndex: s,
          source: l,
          error: o
        };
        e.errors.push(_t3), K.error(o), e.numErrors++;
      } else {
        var _t4 = {
          sourceIndex: s,
          source: l,
          results: r
        };
        e.results.push(_t4), e.numResults += r.length;
      }
    }
  }, {
    key: "_formatResponse",
    value: function _formatResponse(e, t, s) {
      var _this11 = this;

      if (t) if (e.activeSourceIndex === se) {
        var _r = s && Z(s, "sourceIndex") && -1 !== s.sourceIndex ? s.sourceIndex : void 0;

        t.forEach(function (t, s) {
          var o = void 0 !== _r ? _r : s;

          _this11._formatSourceResponse(e, t, o);
        });
      } else this._formatSourceResponse(e, t[0], e.activeSourceIndex);
    }
  }, {
    key: "_getResultsFromSources",
    value: function _getResultsFromSources(e, t) {
      var _this12 = this;

      var s = this.allSources,
          r = !e.location && Z(e, "sourceIndex") ? e.sourceIndex : this.activeSourceIndex,
          o = [];

      if (!s.length) {
        var _e6 = new n("search:no-sources-defined", "At least one source is required.", {
          allSources: s
        });

        return K.error(_e6), Promise.reject(_e6);
      }

      return r === se ? s.forEach(function (s, r) {
        o.push(_this12._getResultsFromSource(e, r, t));
      }) : o.push(this._getResultsFromSource(e, r, t)), m(o);
    }
  }, {
    key: "_getSuggestionsFromSources",
    value: function _getSuggestionsFromSources(e, t) {
      var _this13 = this;

      var s = this.allSources,
          r = this.activeSourceIndex,
          o = [];

      if (!s.length) {
        var _e7 = new n("suggest:no-sources-defined", "At least one source is required.", {
          allSources: s
        });

        return K.error(_e7), Promise.reject(_e7);
      }

      return r === se ? s.forEach(function (s, r) {
        o.push(_this13._getSuggestionsFromSource(e, r, t));
      }) : o.push(this._getSuggestionsFromSource(e, r, t)), m(o);
    }
  }, {
    key: "_getResultsFromSource",
    value: function _getResultsFromSource(e, t, s) {
      var r;
      var o = this.allSources.getItemAt(t),
          _e$location = e.location,
          l = _e$location === void 0 ? null : _e$location,
          i = (null == (r = this.view) ? void 0 : r.spatialReference) || Y,
          a = Z(o, "maxResults") ? o.maxResults : this.maxResults,
          n = !!(o instanceof L && Z(o, "exactMatch")) && o.exactMatch,
          u = this.view;
      return o.getResults({
        view: u,
        sourceIndex: t,
        location: l,
        suggestResult: e,
        spatialReference: i,
        exactMatch: n,
        maxResults: a
      }, s);
    }
  }, {
    key: "_getSuggestionsFromSource",
    value: function _getSuggestionsFromSource(e, t, s) {
      var r = this.allSources.getItemAt(t),
          o = Z(r, "suggestionsEnabled") ? r.suggestionsEnabled : this.suggestionsEnabled,
          l = e.length,
          i = Z(r, "minSuggestCharacters") ? r.minSuggestCharacters : this.minSuggestCharacters;

      if (o && e.trim() && l >= i) {
        var a;

        var _o = (null == (a = this.view) ? void 0 : a.spatialReference) || Y,
            _l = Z(r, "maxSuggestions") ? r.maxSuggestions : this.maxSuggestions,
            _i = this.view,
            _n = !!(r instanceof L && Z(r, "exactMatch")) && r.exactMatch;

        return r.getSuggestions({
          view: _i,
          sourceIndex: t,
          suggestTerm: e,
          spatialReference: _o,
          maxSuggestions: _l,
          exactMatch: _n
        }, s);
      }

      return Promise.resolve(null);
    }
  }, {
    key: "_getLayerSourcePopupTemplate",
    value: function _getLayerSourcePopupTemplate(e) {
      var t = e.layer;
      if (t) return Z(e, "popupTemplate") ? e.popupTemplate : t.popupTemplate;
    }
  }, {
    key: "_getSourceIndexOfResult",
    value: function _getSourceIndexOfResult(e) {
      var t = this.results;
      var s = null;
      return t.some(function (t) {
        return t.results.some(function (r) {
          return r === e && (s = t.sourceIndex, !0);
        });
      }), s;
    }
  }, {
    key: "_goToSearchResult",
    value: function () {
      var _goToSearchResult2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e) {
        var t, s, r;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                t = !!e;

                this._abortGoTo();

                s = new AbortController();
                this._gotoController = s;
                r = {
                  target: {
                    target: e
                  },
                  options: {
                    animate: t,
                    signal: s.signal
                  }
                };
                _context5.next = 7;
                return this.callGoTo(r);

              case 7:
                this._gotoController = null;

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _goToSearchResult(_x3) {
        return _goToSearchResult2.apply(this, arguments);
      }

      return _goToSearchResult;
    }()
  }, {
    key: "_getDefaultSymbol",
    value: function _getDefaultSymbol(e) {
      var t;
      var s = this.defaultSymbols,
          r = null == (t = e.feature) ? void 0 : t.geometry;
      if (!g(r)) return null;

      var o = this._get("defaultSymbol");

      if (o && ("point" === r.type || "multipoint" === r.type)) return o;

      switch (r.type) {
        case "point":
        case "multipoint":
          return s.point;

        case "polyline":
          return s.polyline;

        case "extent":
        case "polygon":
          return s.polygon;

        default:
          return null;
      }
    }
  }, {
    key: "_removeHighlight",
    value: function _removeHighlight() {
      this._handles.remove(W);
    }
  }, {
    key: "_getLayerView",
    value: function () {
      var _getLayerView2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
        var t, s;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                t = this.view;

                if (!(!e || !t || "building-component" === e.layer.type || "subtype-sublayer" === e.layer.type)) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return", Promise.resolve(null));

              case 3:
                s = e.layer;
                _context6.next = 6;
                return t.when();

              case 6:
                return _context6.abrupt("return", t.whenLayerView(s));

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _getLayerView(_x4) {
        return _getLayerView2.apply(this, arguments);
      }

      return _getLayerView;
    }()
  }, {
    key: "_highlightFeature",
    value: function _highlightFeature(e) {
      var t = e.graphic,
          s = e.layerView,
          r = t.attributes,
          o = t.layer,
          l = o.objectIdField,
          i = r && r[l],
          a = s.highlight(i || t);

      this._handles.add(a, W);
    }
  }, {
    key: "_setResultFloor",
    value: function _setResultFloor(e) {
      var t, s, r;
      var o = this.view,
          l = null == (t = e.feature) ? void 0 : t.attributes,
          i = null == (s = e.feature) ? void 0 : s.sourceLayer;

      if (i && "floorInfo" in i && null != i && null != (r = i.floorInfo) && r.floorField && l) {
        var _e8 = l[i.floorInfo.floorField];
        o.emit("select-result-floor", _e8);
      }
    }
  }]);

  return re;
}(B(u.EventedMixin(l)));

re.ALL_INDEX = se, e([b({
  readOnly: !0,
  value: null
})], re.prototype, "activeSource", null), e([b()], re.prototype, "activeSourceIndex", null), e([b()], re.prototype, "allPlaceholder", null), e([b({
  readOnly: !0,
  dependsOn: ["defaultSources.length", "sources.length", "includeDefaultSources"]
})], re.prototype, "allSources", null), e([b()], re.prototype, "autoNavigate", void 0), e([b()], re.prototype, "autoSelect", void 0), e([b()], re.prototype, "defaultPopupTemplate", void 0), e([b({
  readOnly: !0
})], re.prototype, "defaultSources", void 0), e([b()], re.prototype, "defaultSymbol", null), e([b()], re.prototype, "defaultSymbols", void 0), e([b()], re.prototype, "includeDefaultSources", void 0), e([b()], re.prototype, "locationEnabled", null), e([b()], re.prototype, "maxInputLength", void 0), e([b()], re.prototype, "maxResults", void 0), e([b()], re.prototype, "maxSuggestions", void 0), e([b()], re.prototype, "messages", void 0), e([b()], re.prototype, "minSuggestCharacters", void 0), e([b({
  readOnly: !0
})], re.prototype, "placeholder", null), e([b()], re.prototype, "popupEnabled", void 0), e([b({
  type: o
})], re.prototype, "popupTemplate", void 0), e([b({
  type: T
})], re.prototype, "portal", void 0), e([b()], re.prototype, "resultCount", void 0), e([b()], re.prototype, "resultGraphicEnabled", void 0), e([b({
  readOnly: !0
})], re.prototype, "resultGraphic", void 0), e([b({
  readOnly: !0
})], re.prototype, "results", void 0), e([b({
  readOnly: !0
})], re.prototype, "selectedSuggestion", void 0), e([b()], re.prototype, "searchAllEnabled", void 0), e([b({
  readOnly: !0
})], re.prototype, "selectedResult", void 0), e([b()], re.prototype, "searchTerm", null), e([b({
  type: X
})], re.prototype, "sources", void 0), e([b({
  readOnly: !0,
  dependsOn: ["allSources.length", "updating"]
})], re.prototype, "state", null), e([b()], re.prototype, "suggestionDelay", void 0), e([b()], re.prototype, "suggestionCount", void 0), e([b({
  readOnly: !0
})], re.prototype, "suggestions", void 0), e([b()], re.prototype, "suggestionsEnabled", void 0), e([b({
  readOnly: !0
})], re.prototype, "updating", null), e([b()], re.prototype, "view", void 0), e([b()], re.prototype, "clear", null), re = e([w(z)], re);
var oe = re;
export { oe as default };